// Bolds search-term matches inside menu/picker labels.
// Shared by MenuComponent and IconButtonPickerComponent so highlighting looks
// identical everywhere.

function escapeHtml(str) {
  const el = document.createElement('span')
  el.textContent = str
  return el.innerHTML
}

// Returns `text` as HTML with each word-boundary match of any term wrapped in
// <span class="font-bold">. Overlapping matches are merged.
function highlightMatches(text, terms) {
  const ranges = []
  terms.forEach((term) => {
    // Word-boundary match so "co" highlights "Cooper" but not "S[co]tt".
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const regex = new RegExp(`\\b${escaped}`, 'gi')
    let match
    while ((match = regex.exec(text)) !== null) {
      ranges.push([match.index, match.index + term.length])
    }
  })
  if (ranges.length === 0) return escapeHtml(text)

  ranges.sort((a, b) => a[0] - b[0])
  const merged = [ranges[0]]
  for (let i = 1; i < ranges.length; i++) {
    const last = merged[merged.length - 1]
    if (ranges[i][0] <= last[1]) last[1] = Math.max(last[1], ranges[i][1])
    else merged.push(ranges[i])
  }

  let result = ''
  let lastEnd = 0
  merged.forEach(([start, end]) => {
    result += escapeHtml(text.slice(lastEnd, start))
    result += `<span class="font-bold">${escapeHtml(
      text.slice(start, end)
    )}</span>`
    lastEnd = end
  })
  return result + escapeHtml(text.slice(lastEnd))
}

// Bolds matches within the direct text nodes of `el`, leaving child elements
// (icons, forms, etc.) untouched. Restore the original label before re-applying.
export function highlightTextNodes(el, terms) {
  Array.from(el.childNodes).forEach((node) => {
    if (node.nodeType !== Node.TEXT_NODE) return
    const highlighted = highlightMatches(node.textContent, terms)
    if (highlighted === escapeHtml(node.textContent)) return
    const wrapper = document.createElement('span')
    wrapper.innerHTML = highlighted
    node.replaceWith(...Array.from(wrapper.childNodes))
  })
}
